define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		preProcess: function() {
			this.m_lastCurrentElement = this.widget.getRefNodeByUrl(this.getParent().CurrentRevision);
			return this.inherited(arguments);
		},
		
		postProcessSuccess: function() {
			var res = this.inherited(arguments);								
			if (this.m_lastCurrentElement)								
				this.widget.redrawNode(this.m_lastCurrentElement);
				
			return res || this.widget.redrawNode(this.m_element);
		}		
	});
});